export default "__VITE_ASSET__DULgT6Dg__"